import { render, staticRenderFns } from "./CardTotalDataUsage.vue?vue&type=template&id=ff55d2d2&scoped=true&"
import script from "./CardTotalDataUsage.vue?vue&type=script&lang=js&"
export * from "./CardTotalDataUsage.vue?vue&type=script&lang=js&"
import style0 from "./CardTotalDataUsage.vue?vue&type=style&index=0&id=ff55d2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff55d2d2",
  null
  
)

export default component.exports